import { collectionsAccessControl } from 'domains/collections/access-control/collectionsAccess.configuration'
import { collectionsAdminRouter } from 'domains/collections/routing/collectionsAdminRouter'
import { type DomainMessages } from 'domains/collections/utils/domain/intl'
import { collectionsAdminAccessControl } from 'domains/collections/access-control/collectionsAdminAccess.configuration'
import { collectionsRouter } from 'domains/collections/routing/collectionsRouter'
import { navCollectionsAdminRouter } from 'domains/collections/routing/navCollectionsAdminRouter'
import { navCollectionsAdminAccessControl } from 'domains/collections/access-control/navCollectionsAdminAccess.configuration'
import { navCollectionsRouter } from 'domains/collections/routing/navCollectionsRouter'
import { navCollectionsAccessControl } from 'domains/collections/access-control/navCollectionsAccess.configuration'
import { routes } from 'domains/collections/routing/routes'
import EN_US from 'domains/collections/translations/en-US'
import { type RPPDomain } from 'utils/core/RPPCore.types'
import { NavItem } from 'legacy/components/Nav/nav.types'
import { AdminNavEntryPoint } from 'gin-and-tonic/containers/nav/utils/adminNavConfig'
import { type DomainAccessControlConfig } from 'domains/collections/utils/domain/accessControl'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'collections',
  routes,
  translations: { EN_US },
  routers: {
    admin: [collectionsAdminRouter, navCollectionsAdminRouter],
    scoped: [collectionsRouter, navCollectionsRouter],
  },
  navigationEntries: [
    {
      attachTo: NavItem.Merchandising,
      subNavItems: [
        {
          type: 'item',
          labelId: 'collectionsDomain.title',
          route: 'legacy-retailer-collections-list',
          accessControl: collectionsAccessControl,
        },
        {
          type: 'item',
          labelId: 'navCollectionsDomain.title',
          route: 'retailer-nav-collections-list',
          accessControl: navCollectionsAccessControl,
        },
      ],
    },
  ],
  adminNavigationEntries: [
    {
      attachTo: AdminNavEntryPoint.Merchandising,
      subNavItems: [
        {
          route: 'app-admin-collections-list',
          labelId: 'collectionsDomain.title',
          accessControl: collectionsAdminAccessControl,
        },
        {
          route: 'app-admin-nav-collections-list',
          labelId: 'navCollectionsDomain.title',
          accessControl: navCollectionsAdminAccessControl,
        },
      ],
    },
  ],
}

export default definition
